import React from 'react';
import { Spinner } from 'react-bootstrap';
import styles from './LoadingSpinner.module.css';

const LoadingSpinner = ({ centered = true, text = 'Загрузка...' }) => (
  <div className={centered ? styles.centered : ''}>
    <Spinner animation="border" role="status" size="sm" className="me-2">
      <span className="visually-hidden">Loading...</span>
    </Spinner>
    <span>{text}</span>
  </div>
);

export default LoadingSpinner;

